import * as React from 'react'
import { rgba } from 'polished'
import { styled } from '../../../../shared/styled-components'

interface IProps {
  children?: React.ReactNode
}

export const Overlay = ({ children }: IProps) => {
  return <Container>{children}</Container>
}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => rgba(props.theme.darkBlueColor, 0.95)};
`
